import Container from '../Container';
import FilterForm from './FilterForm';

const FilterWrapper = () => {
  return (
    <Container>
      <FilterForm />
    </Container>
  );
};

export default FilterWrapper;
